import { render, staticRenderFns } from "./ServiceDocumentsLayout.vue?vue&type=template&id=06fd8f5c&scoped=true"
import script from "./ServiceDocumentsLayout.vue?vue&type=script&lang=ts"
export * from "./ServiceDocumentsLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd8f5c",
  null
  
)

export default component.exports